export default {
  tiny: '0.25rem',
  small: '0.5rem',
  normal: '1rem',
  medium: '1.5rem',
  large: '2rem'
};
